import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'toggleIcon', 'eye', 'eyeOff'];

  toggle() {
    const type = this.inputTarget.type === 'password' ? 'text' : 'password';
    this.inputTarget.type = type;
    if (type === 'password') {
      this.eyeTarget.classList.remove('hidden');
      this.eyeOffTarget.classList.add('hidden');
    } else {
      this.eyeTarget.classList.add('hidden');
      this.eyeOffTarget.classList.remove('hidden');
    }
  }
}
